import { Link, useParams } from "react-router-dom";
import Results from "../Results.jsx";

export default function ArchiveSeasonResultsDb() {
    const { seasonKey } = useParams();
    const key = String(seasonKey || "").trim() || "active";

    return (
        <>
            <div className="card" style={{ marginBottom: 12 }}>
                <h2 style={{ marginBottom: 8 }}>Archiv {key.toUpperCase()} - Ergebnisse</h2>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Link className="btn" to={`/gt3x/archiv/${key}`}>Zur Season</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/pro`}>Standings</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/incidents`}>Incidents</Link>
                </div>
            </div>

            <Results seasonKey={key} />
        </>
    );
}
